import React from 'react';
import { withRouter } from 'react-router';
import { request } from '../functions/apiRequestWrapper';
import BookListItem from '../components/BookListItem';
import SectionListItem from '../components/SectionListItem';
import Loader from '../components/Loader';
import Breadcrumb from '../components/Breadcrumb';
import DownloadS3Button from '../components/DownloadS3Button';
import Button from 'react-bootstrap/Button';
import { Download } from 'react-bootstrap-icons';
import { PATH_RELEASES } from '../constants';

import { db } from '../db';

import { connect } from 'react-redux';
import { logout } from '../redux/User';
const mapStateToProps = state => {
    return {
        country: state.user.data && state.user.data.country ? state.user.data.country : "AU"
    }
}
const mapDispatchToProps = dispatch => {
    return {
        logout: () => { dispatch(logout()); }
    }
}

class Release extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            releaseData: null,
            sectionInfo: {},
            isLoadingRelease: false,
            isLoadingSection: false
        }
    }

    componentDidMount() {
        setTimeout(() => {window.scrollTo(0, 0);}, 100);
        const { match } = this.props;
        this.getRelease();
        if (match.params.orderFormId) {
            this.getReleaseSection();
        } else {
            this.scrollToSection();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.orderFormId && prevProps.match.params.orderFormId !== this.props.match.params.orderFormId) {
            this.getReleaseSection(this.props.match.params.monthYear, this.props.match.params.orderFormId);
            if (!prevProps.match.params.orderFormId) {
                window.scrollTo(0, 0);
            } else {
                document.getElementById("sectionstop").scrollIntoView();
            }
        }
        if (!this.props.match.params.orderFormId && prevProps.match.params.orderFormId) {
            this.setState({sectionInfo: {}});
        }
    }

    getRelease = (_monthYear) => {
        let monthYear = _monthYear || this.props.match.params.monthYear;
        this.setState({ isLoadingRelease: true });
        return request(
            `${process.env.REACT_APP_API}/1/releases/${monthYear}`
        ).then((data) => {
            // console.log(data);
            this.setState({ releaseData: data, isLoadingRelease: false });
        }).catch((error) => {
            if (error.status === 401) {
                this.props.logout();
            } else {
                db.releases.get(monthYear).then((offlineRelease) => {
                    if (!offlineRelease) {
                        this.setState({ isLoadingRelease: false });
                        return;
                    }
                    console.log("getRelease offline", offlineRelease);
                    return db.sections.where('parentSlug').equals(monthYear).sortBy('idx').then((offlineSections) => {
                        console.log("getRelease offline section", offlineSections);
                        offlineRelease.sections = offlineSections;
                        this.setState({ releaseData: offlineRelease, isLoadingRelease: false });
                    });
                }).catch(() => {
                    this.setState({ isLoadingRelease: false });
                });
            }
        });
    }

    getReleaseSection = (_monthYear, _orderFormId) => {
        const { match } = this.props;
        let monthYear = _monthYear || match.params.monthYear;
        let orderFormId = _orderFormId || match.params.orderFormId;
        if (!orderFormId || typeof orderFormId === "undefined") {
            return;
        }
        this.setState({ isLoadingSection: true });

        request(
            `${process.env.REACT_APP_API}/1/releases/${monthYear}/${orderFormId}/products`
        ).then((data) => {
            this.setState({
                sectionInfo: data.links,
                sectionProducts: data.products,
                isLoadingSection: false
            }, this.scrollToBook);
        }).catch((error) => {
            db.sections.get(orderFormId).then((offlineSection) => {
                console.log("db sections get", orderFormId, offlineSection);
                if (offlineSection.products) {
                    db.products.where("isbn").anyOf(offlineSection.products).toArray().then((offlineProducts) => {
                        // console.log("db products where isbn", offlineProducts);
                        const isbnOrder = offlineSection.products;
                        offlineProducts.sort((a, b) => isbnOrder.indexOf(String(a.isbn)) - isbnOrder.indexOf(String(b.isbn)));
                        this.setState({
                            sectionInfo: offlineSection,
                            sectionProducts: offlineProducts,
                            isLoadingSection: false
                        });
                    });
                } else {
                    this.setState({
                        sectionInfo: offlineSection,
                        sectionProducts: [],
                        isLoadingSection: false
                    }, this.scrollToBook);
                }
            }).catch(() => {
                this.setState({ isLoadingSection: false });
            });
        });
    }
    
    scrollToBook = () => {
        const { location } = this.props;
        if (location.state && location.state.scrollIsbn) {
          setTimeout(()=>{
            let el = document.getElementById(`book${location.state.scrollIsbn}`);
            if (el) {
                el.scrollIntoView();
            }
          }, 500);
        }
    }
    scrollToSection = () => {
        const { location } = this.props;
        if (location.state && location.state.scrollSection) {
          setTimeout(()=>{
            let el = document.getElementById(`section${location.state.scrollSection}`);
            if (el) {
                el.scrollIntoView();
            }
          }, 500);
        }
    }

    render() {
        const { match } = this.props;
        const { releaseData, sectionInfo, sectionProducts, isLoadingRelease, isLoadingSection } = this.state;
        const { monthYear, orderFormId } = match.params;
        const title = releaseData && releaseData.catalogue && releaseData.catalogue.toLowerCase() + " releases";
        let crumbs = [{ link: {pathname: PATH_RELEASES, state: {scrollRelease: releaseData?.slug}}, label: "Releases" }];
        let currentCrumb = title;
        if (orderFormId && sectionInfo.orderFormTitle) {
          crumbs.push({ link: `${PATH_RELEASES}/${monthYear}`, label: title });
          currentCrumb = sectionInfo.orderFormTitle;
        }
        return (
            <div className="page releases container px-3 px-md-5">
                <Breadcrumb crumbs={crumbs}>{currentCrumb}</Breadcrumb>
                
                <h1 className="text-capitalize mb-4">{title}</h1>
                <div className="mb-5">
                    {releaseData?.links?.catalogueOnixBasic &&
                        <DownloadS3Button bucket={'catalogue/onix/' + this.props.country} file={releaseData.links.catalogueOnixBasic} className="me-2 mb-2" label="Short ONIX" />
                    }
                    {releaseData?.links?.catalogueOnixFull &&
                        <DownloadS3Button bucket={'catalogue/onix/' + this.props.country} file={releaseData.links.catalogueOnixFull} className="me-2 mb-2" label="Full ONIX" />
                    }
                    {releaseData?.links?.orderForm &&
                        <Button href={`/order_zips/${this.props.country}/${releaseData.links.orderForm}`} download target="_blank" variant="outline-primary" className="me-2 mb-2"><Download size={16} className="me-1" /> All order forms</Button>
                    }
                    {releaseData?.links?.allCovers &&
                        <Button href={`/covers/${releaseData.links.allCovers}`} download target="_blank" variant="outline-primary" className="me-2 mb-2"><Download size={16} className="me-1" /> Covers</Button>
                    }
                    <Button variant="outline-primary" className="mb-2" href="https://www.simonandschuster.com.au/p/purchasing-books-for-retailers-business" target="_blank" rel="noopener noreferrer">Link to ONIX Files</Button>
                </div>

                {releaseData && releaseData.sections && !orderFormId && <div className="list releases">
                    <div className="row product-row">
                        {releaseData.sections.map(section => {
                            return (
                                <div key={section.orderFormId} className="col-6 col-sm-4 col-md-3" id={`section${section.orderFormId}`}>
                                    <SectionListItem monthYear={monthYear} className="mb-5" {...section} />
                                </div>
                            );
                        })}
                    </div>
                </div>}

                <br />

                <div id="sectionstop" />

                {orderFormId && sectionInfo.orderFormId && !isLoadingSection && <>
                    <div className="mb-4">
                        <h3 className="mb-3">{sectionInfo.orderFormTitle}</h3>
                        <div className="">
                            {sectionInfo.catalogueOnixBasic &&
                                <DownloadS3Button bucket={'catalogue/onix/' + this.props.country} file={sectionInfo.catalogueOnixBasic} className="me-2 mb-2" label="Short ONIX" />
                            }
                            {sectionInfo.catalogueOnixFull &&
                                <DownloadS3Button bucket={'catalogue/onix/' + this.props.country} file={sectionInfo.catalogueOnixFull} className="me-2 mb-2" label="Full ONIX" />
                            }
                            { /* jeff commented this out temporarily
                            sectionInfo.orderForm &&
                                <Button href={sectionInfo.orderForm.indexOf("http") === 0 ? sectionInfo.orderForm : `/orders/${this.props.country}/${sectionInfo.orderForm}`} download target="_blank" variant="outline-primary" className="me-2 mb-2"><Download size={16} className="me-1" /> Order Form</Button>
                            */ }
                        </div>
                    </div>
                    <div className="row product-row">
                        {sectionProducts && sectionProducts.map((product, i) => {
                            return (
                                <div key={product.isbn} className="col-6 col-sm-4 col-md-3" id={`book${product.isbn}`}>
                                    <BookListItem monthYear={monthYear} orderFormId={sectionInfo.orderFormId} className="mb-5" {...product} />
                                </div>
                            );
                        })}
                    </div>
                </>}
                
                {(isLoadingRelease || isLoadingSection) && <Loader type="placeholder" />}
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Release));
